'use client';

import { useAuth } from '@/contexts/AuthContext';
import { LoginForm } from '@/components/auth/LoginForm';
import { usePathname } from 'next/navigation';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, authEnabled, authMethod, login } = useAuth();
  const pathname = usePathname();

  // Always allow /share routes to bypass authentication
  if (pathname.startsWith('/share/')) {
    return <>{children}</>;
  }

  // If authentication is disabled, always show content
  if (!authEnabled) {
    return <>{children}</>;
  }

  // If authentication is enabled but user is not authenticated, show login form
  if (!isAuthenticated) {
    return <LoginForm onLogin={login} authMethod={authMethod} />;
  }

  // User is authenticated, show the protected content
  return <>{children}</>;
}